<!-- Builder Start -->
<div id="{{position}}" class="position-relative">
  <div>
    <div class="">
       <div [id]="'global-map-container-'+position">
        <div class="mapcontainerid" [id]="'map-'+position"></div> 
      </div> 
    </div>
  </div>
</div>

<!-- Builder End -->